/**
 * Loads invoice event detail by ID for internal company manager
 * Simple loader that fetches a single invoice
 */
export async function loadInvoiceDetail(id: string) {
  const module = await import('@/main/factories/usecases/')
  const makeRemote = module.makeRemoteInvoiceEventDetail
  const remoteInvoiceEventDetail = makeRemote()

  return {
    invoice: await remoteInvoiceEventDetail.get(id)
  }
}
